import React from 'react';

import ChecklistIconComplete from '../../icons/ChecklistIconComplete';
import ChecklistIconIncomplete from '../../icons/ChecklistIconIncomplete';

import IconBadge from './IconBadge';

const ChecklistBadge = ({ numComplete = 0, numItems }) => {
  const isComplete = numComplete === numItems;

  const bgColor = isComplete ? 'green-500' : null;
  const fontColor = isComplete ? 'white' : null;
  const icon = isComplete ? (
    <ChecklistIconComplete />
  ) : (
    <ChecklistIconIncomplete />
  );

  return (
    <IconBadge bgColor={bgColor} fontColor={fontColor} icon={icon}>
      {numComplete}/{numItems}
    </IconBadge>
  );
};

export default ChecklistBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/ChecklistBadge.js